export default {
  translation: {
    common: {
      emailOrUsername: '邮箱或用户名',
      invalidEmailOrUsername: '无效的邮箱或用户名',
      invalidPassword: '密码错误',
      noInternetConnection: '没有网络连接',
      pageNotFound_title: '找不到页面',
      password: '密码',
      projectManagement: '项目管理',
      serverConnectionFailed: '服务器连接失败',
      unknownError: '未知错误，请稍后重试',
      useSingleSignOn: '使用单点登录',
    },

    action: {
      logIn: '登录',
      logInWithSSO: '使用SSO登录',
    },
  },
};
